var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.showSettingSectionHeader
        ? _c("fieldset", [
            _c("legend", { staticClass: "col-lg-offset-1 col-lg-10" }, [
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "RPC_SETTINGS_TITLE",
                    expression: "'RPC_SETTINGS_TITLE'"
                  }
                ]
              }),
              _vm._v(" "),
              _c(
                "a",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.right",
                      value: _vm.$t("RPC_SETTINGS_TITLE_TT"),
                      expression: "$t('RPC_SETTINGS_TITLE_TT')",
                      modifiers: { right: true }
                    }
                  ],
                  staticClass: "m-l-10 f-s-16"
                },
                [
                  _vm._v("\n          "),
                  _c("i", { staticClass: "fa fa-question-circle" })
                ]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("ERPCSettings", {
        attrs: {
          rpc: _vm.rpc,
          "priority-bump": _vm.priorityBump,
          "entity-type": _vm.entityType
        },
        on: {
          "update:rpc": function($event) {
            _vm.rpc = $event
          },
          change: _vm.onConfigChange,
          priorityBumpChange: _vm.onPriorityBumpChange
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }